

export const API_BASE_URL = "https://airdriegujaratisamaj.ca/api";
//export const API_BASE_URL = "http://localhost/ags-api/api/";

export async function apiGet(path) {
  try {
    const res = await fetch(`${API_BASE_URL}${path}`);

    if (!res.ok) {
      throw new Error(`API Error: ${res.status}`);
    }

    return await res.json();
  } catch (err) {
    console.error("API GET ERROR:", err);
    return null;
  }
}
